import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { apiLoadProductSettings, apiSaveProductSettings } from '../../api/productSettingApi'
import { loadProductSettings } from '../../reducers/product-settings'
import Heading from '../Heading'
import Loading from '../Loading'
import SaveButton from '../SaveButton'
import ProductPicker from '../ProductPicker'
import SelectProductsItem from '../SelectProductsItem'

const ProductsTab = () => {
  const [saving, setSaving] = useState(false);

  const dispatch = useDispatch();
  const loaded = useSelector(state => {
    return state.productSettings.loaded;
  });
  useEffect(() => {
    if (!loaded) {
      apiLoadProductSettings(response => {
        dispatch(loadProductSettings(response));
      });
    }
  }, [loaded]);
  const productSettings = useSelector(state => {
    return state.productSettings.list;
  });
  const handleSaveChanges = (e) => {
    e.preventDefault();
    setSaving(true);
    apiSaveProductSettings(productSettings, response => {
      setSaving(false);
    })
  }

  return (
    <div className="dreamfox-tab">
      <Heading text="Products" />
      {!loaded && <Loading message="Loading..." />}
      {loaded &&
        <div className="dreamfox-tab__content">
          <h3>Product Overrides</h3>
          <p>Set a custom lead time for specific products, on top of the global and category settings.</p>
          <p>-- Set blank &gt;&gt; use the global/category setting.</p>
          <p>-- Set 0 &gt;&gt; for today's delivery date.</p>
          <ProductPicker />
          <div className="dreamfox-select-products">
            <div className="dreamfox-select-products__header">
              <div>Product</div>
              <div>Days</div>
            </div>
            {productSettings && productSettings.map(item => {
                return (<SelectProductsItem key={item.id} item={item}></SelectProductsItem>)
              })
            }
          </div>
          <SaveButton saving={saving} onClick={handleSaveChanges} />
        </div>
      }
    </div>
  )
}

export default ProductsTab
